import { getPublishUrl } from '@buffer-mono/shared-utils/urls'

// Keep in sync with `LINKEDIN_CAPABILITIES_SCROLL_HASH` in
// services/publish/publish-frontend/src/legacy/general-settings/components/LinkedInVerifiedSkills/config.ts.
export const LINKEDIN_CAPABILITIES_SECTION_ID = 'linkedin-capabilities'
export const LINKEDIN_CAPABILITIES_QUERY_PARAM = 'linkedincapabilities'

export const CONNECT_PROFILE_CTA =
  'publish-linkedInCapabilities-connectLinkedInProfile-1'

export function getChannelSettingsRoute(channelId: string): string {
  return getPublishUrl(
    `channels/${channelId}/settings?tab=general#${LINKEDIN_CAPABILITIES_SECTION_ID}`,
  )
}
